import React from "react";
import { Dialog } from "@app/components";
import {
  FormFlexWrapper,
  FormWrapper,
  CommonLabel,
} from "@app/components/commonStyles";
import { SampleTextBox, Value } from "../educator-component";
type Props = {
  planType: string;
  onClose: (e: any) => void;
};
const sampleValues = {
  subject: "Social Studies",
  topic: "Civil Rights",
  esQues:
    "How do the individuals and the events leading up to the March on Washington represent the Civil Rights movement as a whole?",
  grade: "4/5th Grade",
  skills:
    "1.Use direct quotes from texts\n2.Compares multiple perspectives on the same event, idea, or theme.\n3.Uses technology and digital media to further their understanding of a topic and to find answers to their questions\n4.Gathers information about a topic from multiple sources",
  standard:
    "Common Core :\n\nRI 5.3-Explain relationship between two or more individuals\nRI 5.5- Cause/Effect\nRI 5.6- Analyze multiple accounts\nRI 5.9-Intergrate information from several texts\nNational Social Studies:\n\nD2.Civ.12.3-5. Explain how rules and laws change society and how people change rules and laws.\nD2.Civ.14.3-5. Illustrate historical and contemporary means of changing society.\nD2.His.1.3-5. Create and use a chronological sequence of related events to compare developments that happened at the same time.\nD2.His.3.3-5. Generate questions about individuals and groups who have shaped significant historical changes and continuities.\nD2.His.14.3-5. Explain probable causes and effects of events and developments.",
  lesDes:
    "Brown v Board of Education (1954) - How does Barbara Johns’ high school protest lead to one of the most important decisions in Supreme Court history.\n\n Montgomery Bus Boycott (1955-1956) - How did thousands of individuals help change the bus segregation laws in their town?\n\nLittle Rock Nine (1957) - Nine brave students help change the public perception of segregated schools.\n\nGreensboro Sit In (1960) - Four students spark a movement to help end segregation in many public facilities.\n\nRuby Bridges (1960) - Students learn what life was like for young black children in the segregated south.\n MLK I Have a Dream Speech (1963) - How Dr. King’s speech still resonates with the Black Lives Matter movement of today?",
  obj: "This is an introductory unit to the Civil Rights movement. Students are taken through key events in American history that lead up to the March on Washington in 1963. In each lesson, students will be introduced to key individuals and groups who were involved and how they made a change for their community. Students will use primary source documents to gather information about each event. The final lesson will be about Martin Luther King Jr.’s famous I Have a Dream Speech. When the students hear this speech, they will have all this knowledge they gathered throughout the unit and be able to  understand the context of Dr. King’s speech and how the Civil Rights movement led to actual change in America. Since this is an introductory unit, the fifth grade students will be able to demonstrate the main idea of each event and some of the key figures involved.",
  special:
    "A majority of students in the educational system are generally taught about a few individuals in the Civil Rights Movement- Martin Luther King Jr. and Rosa Parks. These individuals are important and inspirational figures in American history and should be taught and discussed about; however, they were just two people among thousands of individuals who helped make change in this country. This unit is designed to teach about the unknown people who were involved in the moment. People like Claudette Colvin, who sat in the front of the bus six months before Rosa Parks did. Or Barbara Johns, a sixteen year old who led a protest that sparked the beginnings of the famous Brown vs. Board of Education Supreme court hearing.\n\n\n\n\nWith the Black Lives Matter movement happening since 2013, it is important for students to understand the historical relevance of the Civil Rights Movement and how the fight for racial equality still goes on. Using the knowledge that was gained during this unit, students will have a better idea of how important it is to still fight for people of color. ",
};

export default function SubmitContentComponent({ planType, onClose }: Props) {
  return (
    <Dialog
      title={
        planType === "lessonPlan" ? `Sample Lesson Plan` : `Sample Unit Plan`
      }
      onClose={onClose}
    >
      <FormWrapper className="alt-padding">
        <FormFlexWrapper>
          <div className="child only-child">
            <CommonLabel>Subject</CommonLabel>
            <SampleTextBox>{sampleValues.subject}</SampleTextBox>
          </div>
        </FormFlexWrapper>
        <FormFlexWrapper>
          <div className="child only-child">
            <CommonLabel>Topic</CommonLabel>
            <SampleTextBox>{sampleValues.topic}</SampleTextBox>
          </div>
        </FormFlexWrapper>
        <FormFlexWrapper>
          <div className="child only-child">
            <CommonLabel>Grade</CommonLabel>
            <SampleTextBox>{sampleValues.grade}</SampleTextBox>
          </div>
        </FormFlexWrapper>
        <FormFlexWrapper>
          <div className="child only-child">
            <CommonLabel>Essential Questions</CommonLabel>
            <SampleTextBox>{sampleValues.esQues}</SampleTextBox>
          </div>
        </FormFlexWrapper>

        <FormFlexWrapper>
          <div className="child only-child">
            <CommonLabel>Key Skills</CommonLabel>
            <SampleTextBox>
              {sampleValues.skills.split("\n").map((data, i) => {
                return <Value>{data}</Value>;
              })}
            </SampleTextBox>
          </div>
        </FormFlexWrapper>
        <FormFlexWrapper>
          <div className="child only-child">
            <CommonLabel>Standards</CommonLabel>
            <SampleTextBox>
              {sampleValues.standard.split("\n").map((data, i) => {
                return <Value>{data}</Value>;
              })}
            </SampleTextBox>
          </div>
        </FormFlexWrapper>
        {planType === "lessonPlan" && (
          <>
            <FormFlexWrapper>
              <div className="child only-child">
                <CommonLabel>Lesson Description</CommonLabel>
                <SampleTextBox>
                  {sampleValues.lesDes.split("\n").map((data, i) => {
                    return <Value>{data}</Value>;
                  })}
                </SampleTextBox>
              </div>
            </FormFlexWrapper>
            <FormFlexWrapper>
              <div className="child only-child">
                <CommonLabel>Lesson Objective</CommonLabel>
                <SampleTextBox>{sampleValues.obj}</SampleTextBox>
              </div>
            </FormFlexWrapper>
          </>
        )}
        {planType === "unitPlan" && (
          <>
            <FormFlexWrapper>
              <div className="child only-child">
                <CommonLabel>Lessons in the Unit</CommonLabel>
                <SampleTextBox>
                  {sampleValues.lesDes.split("\n").map((data, i) => {
                    return <Value>{data}</Value>;
                  })}
                </SampleTextBox>
              </div>
            </FormFlexWrapper>
            <FormFlexWrapper>
              <div className="child only-child">
                <CommonLabel>Unit Objective</CommonLabel>
                <SampleTextBox>{sampleValues.obj}</SampleTextBox>
              </div>
            </FormFlexWrapper>
          </>
        )}
        <FormFlexWrapper>
          <div className="child only-child">
            <CommonLabel>What makes this special</CommonLabel>
            <SampleTextBox>
              {sampleValues.special.split("\n").map((data, i) => {
                return <Value>{data}</Value>;
              })}
            </SampleTextBox>
          </div>
        </FormFlexWrapper>
      </FormWrapper>
    </Dialog>
  );
}
